// Application ID associated with the deposits WebPaymentsSDK form.
// As staging and production requires different IDs, they have to be retrieved from different locations.
// To retrieve staging IDs, go to https://squareupstaging.com/us/en/developers and log into the Developer Dashboard
// To retrieve production IDs, go to https://squareup.com/us/en/developers and log into the Developer Dashboard
// Select the 'Dashboard - Balance App' application to view the credentials.
// Account email: bat-team+developer@squareup.com
import environment from '@square/environment-utils/environment';
const DEPOSITS_PAYMENT_FORM_STAGING_APP_ID = 'sq0ids-saYDX65Eq1UEdUqY5vRoqA';
const DEPOSITS_PAYMENT_FORM_SANDBOX_APP_ID = 'sandbox-sq0idb-mr4Jy578mYzU6gMp2p1qkw';
const DEPOSITS_PAYMENT_FORM_PRODUCTION_APP_ID = 'sq0idp-uAuxtGThhLpKx2OUpu_E2Q';
const DEPOSITS_PAYMENT_FORM_STAGING_LOCATION_ID = 'LKRSHYZ4MREQD';
const DEPOSITS_PAYMENT_FORM_SANDBOX_LOCATION_ID = 'L1SQ1S8N7T91N';
const DEPOSITS_PAYMENT_FORM_PRODUCTION_LOCATION_ID = 'L1REZ1RM5FS98';
const isProduction = environment().isProduction;
const isSandbox = environment().isSandbox;
let depositsPaymentFormAppId;
let depositsPaymentFormLocationId;
if (isProduction) {
  // production
  depositsPaymentFormAppId = DEPOSITS_PAYMENT_FORM_PRODUCTION_APP_ID;
  depositsPaymentFormLocationId = DEPOSITS_PAYMENT_FORM_PRODUCTION_LOCATION_ID;
} else if (isSandbox) {
  // sandbox
  depositsPaymentFormAppId = DEPOSITS_PAYMENT_FORM_SANDBOX_APP_ID;
  depositsPaymentFormLocationId = DEPOSITS_PAYMENT_FORM_SANDBOX_LOCATION_ID;
} else {
  // staging
  depositsPaymentFormAppId = DEPOSITS_PAYMENT_FORM_STAGING_APP_ID;
  depositsPaymentFormLocationId = DEPOSITS_PAYMENT_FORM_STAGING_LOCATION_ID;
}
export const APP_ID = depositsPaymentFormAppId;
export const LOCATION_ID = depositsPaymentFormLocationId;